import { render, staticRenderFns } from "./certificationInfo2.vue?vue&type=template&id=1396bbb2"
import script from "./certificationInfo2.vue?vue&type=script&lang=js"
export * from "./certificationInfo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports